export interface UserTypeAndRegionDto {
  type: string;
  region: string;
}

export enum AccountRegion {
  Global = "global",
  EU = "eu",
}
